import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, UploadService} from '../../_services/index';
import {LoginHelper} from '../../helpers';
import {ListMessageComponent} from "../listMessage";
import {WorkstreamService} from "../../_services/workstream.service";
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";

@Component({
    standalone: false,
    selector: 'workstream-upload',
    templateUrl: 'workstream-upload.component.html',
    styleUrls: ['./workstream-upload.component.scss'],
})

export class WorkstreamUploadComponent implements OnInit {
    loading = false;
    name: string;

    constructor(
      public dialogRef: MatDialogRef<WorkstreamUploadComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public router: Router,
      public route: ActivatedRoute,
      public workstreamService: WorkstreamService,
      public alertService: AlertService,
      public authenticationService: AuthenticationService,
      public dialog: MatDialog) {
    }

    ngOnInit() {
        let tenantName = LoginHelper.getTenantName();
        if (tenantName == null || LoginHelper.getUserToken() == null){
            this.authenticationService.logout();

            return;
        }
    }

    onClose(): void {
        this.dialogRef.close();
    }

    upload(event) {
        if (this.name == null){
            this.alertService.error('You should fill the name.', true);
            return;
        }

        this.loading = true;

        this.alertService.clear();

        let attachments = event.target.files;
        if (attachments.length > 0) {
            let file:File = attachments[0];

            this.workstreamService.upload(file, this.name).subscribe(
                (res) => {
                    this.alertService.success('Upload complete.', true);
                    let config: MatDialogConfig = {
                        panelClass: 'custom-overlay-pane-class',
                        width: 'auto',
                        height: '90%',
                        data: {
                            items: res,
                            title: "Upload report"
                        }
                    };
                    this.dialog.open(ListMessageComponent, config);
                    this.loading = false;
                    this.onClose();
                },
                () => {
                    this.loading = false;
                  const message = "An error occurred while updating.";
                  this.alertService.error(message);
                }
            );
        }
    }
}
